var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVkIcon = function SvgVkIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1006_2381)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0026 4.17873C17.1194 3.78948 17.0026 3.50342 16.447 3.50342H14.6098C14.1425 3.50342 13.9272 3.75048 13.8106 4.0231C13.8106 4.0231 12.8761 6.30039 11.5525 7.77977C11.1244 8.20802 10.9298 8.34442 10.696 8.34442C10.5794 8.34442 10.4103 8.20802 10.4103 7.81895V4.17873C10.4103 3.71167 10.2746 3.50342 9.88539 3.50342H6.99792C6.70607 3.50342 6.53029 3.72025 6.53029 3.92588C6.53029 4.36869 7.19217 4.47095 7.26046 5.7167V8.42224C7.26046 9.01544 7.15335 9.1233 6.91973 9.1233C6.29704 9.1233 4.78184 6.83556 3.88316 4.21792C3.70701 3.70905 3.53049 3.5036 3.061 3.5036H1.22372C0.69862 3.50342 0.59375 3.75048 0.59375 4.02292C0.59375 4.50957 1.21644 6.92326 3.49391 10.1155C5.0121 12.2953 7.15112 13.4773 9.09774 13.4773C10.2655 13.4773 10.4101 13.2147 10.4101 12.7626V11.1151C10.4101 10.59 10.5208 10.4853 10.8906 10.4853C11.163 10.4853 11.6301 10.6213 12.7202 11.6725C13.966 12.9182 14.1713 13.4771 14.8721 13.4771H16.7094C17.2341 13.4771 17.4967 13.2145 17.3453 12.6967C17.1795 12.1804 16.5848 11.4314 15.7956 10.5437C15.3674 10.0376 14.7249 9.49258 14.5303 9.21996C14.2576 8.86971 14.3356 8.71408 14.5303 8.40246C14.5303 8.40246 16.7691 5.24926 17.0026 4.17873Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1006_2381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "vk-icon.c02a1e84f375afd9e547e31647ef3f4c.svg";